export const GET_REWARDS_FETCHING = 'GET_REWARDS_FETCHING';
export const GET_REWARDS_FETCH = 'GET_REWARDS_FETCH';
export const GET_REWARDS_FETCH_ERROR = 'GET_REWARDS_FETCH_ERROR';
export const REDEEM_REWARD_IDLE = 'REDEEM_REWARD_IDLE';
export const REDEEM_REWARD_FETCHING = 'REDEEM_REWARD_FETCHING';
export const REDEEM_REWARD_FETCH = 'REDEEM_REWARD_FETCH';
export const REDEEM_REWARD_FETCH_ERROR = 'REDEEM_REWARD_FETCH_ERROR';
export const GET_VAULT_ITEMS_REWARDS_FETCHING = 'GET_VAULT_ITEMS_REWARDS_FETCHING';
export const GET_VAULT_ITEMS_REWARDS_FETCH = 'GET_VAULT_ITEMS_REWARDS_FETCH';
export const GET_VAULT_ITEMS_REWARDS_FETCH_ERROR = 'GET_VAULT_ITEMS_REWARDS_FETCH_ERROR';
export const GET_VAULT_ITEM_BALANCE_IDLE = 'GET_VAULT_ITEM_BALANCE_IDLE';
export const GET_VAULT_ITEM_BALANCE_FETCHING = 'GET_VAULT_ITEM_BALANCE_FETCHING';
export const GET_VAULT_ITEM_BALANCE_FETCH = 'GET_VAULT_ITEM_BALANCE_FETCH';
export const GET_VAULT_ITEM_BALANCE_FETCH_ERROR = 'GET_VAULT_ITEM_BALANCE_FETCH_ERROR';
export const REDEEM_VAULT_ITEM_REWARD_IDLE = 'REDEEM_VAULT_ITEM_REWARD_IDLE';
export const REDEEM_VAULT_ITEM_REWARD_FETCHING = 'REDEEM_VAULT_ITEM_REWARD_FETCHING';
export const REDEEM_VAULT_ITEM_REWARD_FETCH = 'REDEEM_VAULT_ITEM_REWARD_FETCH';
export const REDEEM_VAULT_ITEM_REWARD_FETCH_ERROR = 'REDEEM_VAULT_ITEM_REWARD_FETCH_ERROR';
export const GET_REDEMPTION_DETAIL_FETCHING = 'GET_REDEMPTION_DETAIL_FETCHING';
export const GET_REDEMPTION_DETAIL_FETCH = 'GET_REDEMPTION_DETAIL_FETCH';
export const GET_REDEMPTION_DETAIL_FETCH_ERROR = 'GET_REDEMPTION_DETAIL_FETCH_ERROR';
